import type {
    FC
} from "react";
import DeprecatedPage, {
    getDeprecatedToc
} from "./deprecated";
import WhatsNewPage, {
    getWhatsNewToc
} from "./whatsNew";
import type {
    DocsTranslate
} from "../../anatomy/types";
import type {
    DocsTocItem
} from "../../components/toc";
import {
    RELEASE_NOTES_PATHS
} from "../../nav";

export const RELEASE_NOTE_PAGES: Record<string, {
    getToc: (t: DocsTranslate) => Array<DocsTocItem>;
    Page: FC;
}> = {
    [RELEASE_NOTES_PATHS.deprecated]: {
        getToc: getDeprecatedToc,
        Page: DeprecatedPage
    },
    [RELEASE_NOTES_PATHS.whatsNew]: {
        getToc: getWhatsNewToc,
        Page: WhatsNewPage
    }
};
